import { __rest } from "tslib";
import { motion, useAnimation } from 'framer-motion';
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { Transition } from 'react-transition-group';
import { useAnimatedContext } from './AnimatedProvider';
export const AnimatedRouteContext = createContext({
    // Cannot remove default values!
    registerAnimatedImage: () => { },
    unregisterAnimatedImage: () => { },
});
export const useAnimatedRouteContext = () => useContext(AnimatedRouteContext);
// Component
const AnimatedRoute = (props) => {
    const { path, exact, children } = props, rest = __rest(props, ["path", "exact", "children"]);
    const el = useRef();
    const endListener = useRef(() => { });
    const [animatedImages, setanimatedImages] = useState([]);
    const { subscribe, unsubscribe, submitEnter, submitExit } = useAnimatedContext();
    const { pathname } = useLocation();
    const animation = useAnimation();
    useEffect(() => {
        const onAppMounted = () => {
            animation.set({
                opacity: 1,
                pointerEvents: 'all',
                position: 'static',
            });
        };
        subscribe('appMounted', onAppMounted);
        return () => {
            unsubscribe('appMounted', onAppMounted);
        };
    }, []);
    const done = () => {
        endListener.current();
    };
    const handleEntering = () => {
        // console.info('%c [transition] handleEntering', 'color: green;');
        submitEnter({
            el,
            done,
            animation,
            animatedImages,
        });
    };
    const handleExit = () => {
        // console.info('%c [transition] handleExit', 'color: red;');
        submitExit({
            el,
            done,
            animation,
            animatedImages,
        });
    };
    const methods = {
        registerAnimatedImage(image) {
            // console.info('%c registerAnimatedImage transition', 'background-color: green;', image);
            setanimatedImages((state) => {
                if (typeof state != 'object') {
                    return state;
                }
                if (!state.find((el) => el.productUuid == image.productUuid)) {
                    // console.info('%c [transition] registerAnimatedImage - add: ', 'background-color: blue;', image, '\n current state: ', state);
                    state.push(image);
                }
                else if (!state.find((el) => el.productId == image.productId)) {
                    // console.info('%c [transition] registerAnimatedImage - add: ', 'background-color: blue;', image, '\n current state: ', state);
                    state.push(image);
                }
                return state;
            });
        },
        unregisterAnimatedImage(productId, productUuid) {
            // console.info('%c unregisterAnimatedImage transition', 'background-color: red;', productId);
            setanimatedImages((state) => {
                if (typeof state != 'object') {
                    return state;
                }
                // console.info('%c [transition] unregisterAnimatedImage - remove: ', 'background-color: purple;', productId, '\n current state: ', state);
                return state.filter((image) => {
                    return image.productUuid !== productUuid;
                });
            });
        },
    };
    const initialStyle = {
        opacity: 0,
        pointerEvents: 'none',
        width: '100%',
        top: 0,
        left: 0,
        zIndex: 1,
        backgroundColor: '#fff',
        position: 'absolute',
    };
    return (React.createElement(AnimatedRouteContext.Provider, { value: methods },
        React.createElement(Route, Object.assign({ exact: exact, path: path }, rest), (location) => {
            var _a;
            return (React.createElement(Transition, { appear: true, unmountOnExit: true, onEntering: handleEntering, onExit: handleExit, in: pathname === ((_a = location.match) === null || _a === void 0 ? void 0 : _a.url), 
                //@ts-ignore
                addEndListener: (node, done) => {
                    endListener.current = done;
                } },
                React.createElement(motion.div, { ref: el, animate: animation, initial: initialStyle },
                    React.createElement(React.Fragment, null, children))));
        })));
};
export default AnimatedRoute;
